import { render, staticRenderFns } from "./CreditNotesView.vue?vue&type=template&id=62e9a338"
import script from "./CreditNotesView.vue?vue&type=script&lang=js"
export * from "./CreditNotesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports